"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EReliabilityTheme = void 0;
let EReliabilityTheme = exports.EReliabilityTheme = /*#__PURE__*/function (EReliabilityTheme) {
  EReliabilityTheme["Red"] = "red";
  EReliabilityTheme["Green"] = "green";
  return EReliabilityTheme;
}({});